import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import symbolsConfig from 'pxc-editor-data/d/toc.json';
import { filterSelectedSectionsForMode, SymbolEntity, getSymbolCategoryByMaterial } from '@/helpers';
import { MIDDLE, CENTER } from '@/constants';
import { updateSelectedSectionsProps } from '@/actions';
import { SymbolButtonWebComponent } from '../ImagesAndSymbols/Symbol/InsertSymbolForm/InsertSymbolForm';
import { ListContainer } from './styles';

const SymbolList = () => {
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.core.mode);
  const pages = useSelector((state) => state.core.pages);
  const shieldsSelection = useSelector((state) => state.core.shieldsSelection);
  const sectionsSelection = useSelector((state) => state.core.sectionsSelection);
  const [sectionsToFormat] = filterSelectedSectionsForMode(mode, pages, shieldsSelection, sectionsSelection);
  const symbolsList = symbolsConfig;
  const symbolFont = getSymbolCategoryByMaterial();

  const handleClick = unicode => {
    dispatch(updateSelectedSectionsProps({
      symbol: { unicode, horizontalAlignment: CENTER, verticalAlignment: MIDDLE },
      symbolFont
    }));
  };

  const handleDragStart = unicode => {
    SymbolEntity.setSymbol({ symbol: { unicode }, symbolFont });
  };

  return (
    <ListContainer>
      {symbolsList[symbolFont].glyphs.map(item => (
        <SymbolButtonWebComponent
          key={`${symbolFont}-${item.unicode}`}
          item={item}
          selected={item.unicode === sectionsToFormat?.glyph?.unicode}
          onClick={handleClick}
          handleDragStart={handleDragStart}
        />
      ))}
    </ListContainer>
  );
};

export default SymbolList;
